module.exports = __webpack_public_path__ + "static/media/bg.2df74e03.jpg";